// App version - increment by 1 on every change deployed.
// IMPORTANT: Edit this file (do NOT hardcode elsewhere) so version is single-sourced.
export const APP_VERSION = "1.0.28";
